import React, { HTMLAttributes } from "react";
import styled from "styled-components";
import SearchIcon from "@mui/icons-material/Search";

const Container = styled.div`
  display: flex;
  font-size: 1rem;
  padding: 56px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 120px;
    margin-bottom: 24px;
    color: #999999;
  }
`;

interface ICustomNoContentTableBodyProps
  extends HTMLAttributes<HTMLDivElement> {
  description: string;
}

const CustomNoContentTableBody: React.FC<ICustomNoContentTableBodyProps> = ({
  description,
}) => {
  return (
    <Container>
      <SearchIcon />
      <p>{description}</p>
    </Container>
  );
};

export { CustomNoContentTableBody };
